import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import GUI from 'lil-gui'
// import typefaceFont from './fonts/helvetiker_regular.typeface.json'

/**
 * Base
 */
// Debug
const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load(
    './textures/matcaps/6.png'
)
matcapTexture.colorSpace = THREE.SRGBColorSpace

/**
 * FontLoader
 */
const fontLoader = new FontLoader()

fontLoader.load(
    './fonts/helvetiker_regular.typeface.json',
    (font) =>
    {
        const textGeo = new TextGeometry(
            'Girls rule',
            
            {
                font: font,
                size: 0.5,
                depth: 0.2,
                curveSegments: 4,
                bevelEnabled: true,
                bevelThickness: 0.03,
                bevelSize: 0.02,
                bevelOffset: 0,
                bevelSegments: 3
            }
        )
        textGeo.center()

        const material = new THREE.MeshMatcapMaterial({
            matcap: matcapTexture
        })


        const textMesh = new THREE.Mesh(textGeo, material)

        scene.add(textMesh)

        const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45)

        const settings = {
            donutsTotal: 100
        }

        gui.add(settings, 'donutsTotal')
            .min(0).max(1000).step(1)
            .name('Donuts total')
            .onFinishChange(() => {
                createDonuts(settings.donutsTotal)
            })

            const createDonuts = (count) => {
                // Clear existing donuts
                for (let i = scene.children.length - 1; i >= 0; i--) {
                    const obj = scene.children[i]
                    if (obj.geometry === donutGeometry) {
                        scene.remove(obj)
                    }
                }
            
                // Add new donuts
                for (let i = 0; i < count; i++) {
                    const donut = new THREE.Mesh(donutGeometry, material)
            
                    donut.position.x = (Math.random() - 0.5) * 10
                    donut.position.y = (Math.random() - 0.5) * 10
                    donut.position.z = (Math.random() - 0.5) * 10
            
                    donut.rotation.x = Math.random() * Math.PI
                    donut.rotation.y = Math.random() * Math.PI
            
                    const scale = Math.random()
                    donut.scale.set(scale, scale, scale)
            
                    scene.add(donut)
                }
            }
            
            createDonuts(settings.donutsTotal)
    }
)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 2
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()